import { InjectionToken } from '@angular/core';
import { SvgIconManifest } from '../services/svg-icons.service';

export const SVG_ICONS = new InjectionToken<SvgIconManifest>('SVG_ICONS', {
  providedIn: 'root',
  factory: () => ({}),
});
